import axios from 'axios'
import { Toast, Dialog } from 'vant'
// 接口基础地址（切换环境时与下方的 WebSocket 地址成对修改）
//export const baseURL = "http://192.168.88.45:7081/api"
// 审方排队的 WebSocket 地址，生产环境为独立域名，不能由 baseURL 推导
//export const wsBaseURL = "ws://192.168.88.45:7081"
export const baseURL = "https://ycsfapi.yxtsml.cn/api"
export const wsBaseURL = "wss://ycsfapi.yxtsml.cn"

// 创建axios实例
const service = axios.create({
  baseURL,
  timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 显示加载提示
    const token = localStorage.getItem('token')
    console.log("头部信息"+token)
    if (token) {
      config.headers['Authori-Zation'] = `${token}`
    }

    if (config.showLoading !== false) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
    }
    return config
  },
  error => {
    Toast.clear()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    Toast.clear()
    const res = response.data
    if (res.code !== 200) {
      // 可以根据业务需求自定义错误处理
      if (res.code === 401) {
        Dialog.alert({
          title: '提示',
          message: '登录已过期，请重新登录'
        }).then(() => {
          // 跳转到登录页
        })
      } else {
        Toast.fail(res.message || 'Error')
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Toast.clear()
    Toast.fail('网络错误或服务器异常')
    return Promise.reject(error)
  }
)
export default service